import BaseController from "./BaseController";
import DataService from "../util/DataService";
import JSONModel from "sap/ui/model/json/JSONModel";

/**
 * @namespace com.reply.leaviosa.controller
 */
export default class Calendar extends BaseController {

    public onInit(): void {
        const router = this.getOwnerComponent().getRouter();
        router.getRoute("calendar").attachPatternMatched(this.onObjectMatched, this);

        this.getView().setModel(new JSONModel({
            selectedCalendars: [],
            displayedCalendars: []
        }), "viewModel");
    }

    async onObjectMatched(): Promise<void> {
        DataService.listCalendars();
        this.loadCalendars();
    }

    onCalendarSelected(): void {
        this.loadCalendars();
    }

    async loadCalendars(): Promise<void> {
        const viewModel = this.getView().getModel("viewModel") as JSONModel;
        const selectedCalendars = viewModel.getProperty("/selectedCalendars") || [];

        const calendarPromises = selectedCalendars.map(async (calendar: any) => {
            const loadedCalendar = await DataService.getCalendar(calendar);
            if (loadedCalendar) {
                return loadedCalendar;
            }
        });

        const loadedCalendars = await Promise.all(calendarPromises);
        const displayedCalendars = loadedCalendars.filter(calendar => calendar !== undefined);

        viewModel.setProperty("/displayedCalendars", displayedCalendars);
    }

}